import { motion } from "framer-motion";

// Real client testimonials — do not paraphrase or edit.
const REVIEWS = [
  {
    q: "It's been five months training with Dr Pradnya and Dr Srushti, and I can wholeheartedly recommend PLST. My energy levels are back, my sugar is at an all-time low, and I can feel a spring in my step.",
    n: "Sneha Subhedar",
    r: "Training with PLST",
  },
  {
    q: "Training with Dr Yuvraj has made me feel stronger and more confident — not just in pursuing my passion for dance, but also in managing the demands of work and home.",
    n: "Nisha Manke",
    r: "Training with PLST",
  },
  {
    q: "My physician advised me to build muscle to help manage my diabetes. With Dr Priyal guiding my training, I'm getting stronger, building muscle, and working towards getting back to playing pickleball with confidence.",
    n: "Amit A.",
    r: "Training with PLST",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-40 bg-[#F5F4EF]" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
          <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
          In their words
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="mt-6 italic font-medium text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] max-w-3xl"
        >
          Real people. <br />
          <span className="text-[#A67C00]">Real progress.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {REVIEWS.map((t, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative bg-white border border-[#1E1E1E]/10 p-8 lg:p-10 hover:border-[#A67C00] transition-colors flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <div className="italic font-medium text-6xl text-[#A67C00] leading-none">"</div>
              <p className="mt-2 italic font-medium text-lg md:text-xl text-[#1E1E1E]/85 leading-snug flex-1">
                {t.q}
              </p>
              <div className="mt-8 pt-6 border-t border-[#1E1E1E]/10">
                <div className="text-[15px] font-semibold text-[#1E1E1E]">{t.n}</div>
                <div className="text-[10px] uppercase tracking-[0.24em] text-[#A67C00] font-semibold mt-2">{t.r}</div>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
